import { AuthenticatedUser } from '@tmx/data-access';
import { TrackJS } from 'trackjs';

export function setTrackJsMetadata(user: AuthenticatedUser) {
  if (TrackJS.isInstalled()) {
    TrackJS.configure({ userId: user.username });
    TrackJS.addMetadata('accountId', user.accountId.toString());
    TrackJS.addMetadata('accountName', user.accountName ?? '');
    TrackJS.addMetadata('userId', user.userId.toString());
  }
}
